import { ReactNode } from "react";
import Warning from "@/assets/icons/common/warning";
import styled from "styled-components";

export function WarningModalContent({
  icon = <Warning />,
  title,
  tip,
}: {
  icon?: ReactNode;
  title?: string;
  tip?: string;
}) {
  return (
    <WarningModalContentWrapper>
      <WarningTitleWrapper>
        {icon}
        <span className="title">{title}</span>
      </WarningTitleWrapper>
      <div className="warning-content">{tip}</div>
    </WarningModalContentWrapper>
  );
}

const WarningModalContentWrapper = styled.div`
  .warning-content {
    line-height: 20px;
    font-size: 12px;
    margin-top: 12px;
  }
`;

const WarningTitleWrapper = styled.div`
  display: flex;
  align-items: flex-start;

  height: 23px;
  gap: 10px;
  &.title {
    vertical-align: bottom;
  }
`;
